import { useEffect } from "react"

const OAuth2RedirectHandler = () => {
  useEffect(() => {
    const url = new URL(window.location.href)
    const accessToken = url.searchParams.get("accessToken")
    const refreshToken = url.searchParams.get("refreshToken")

    if (accessToken && refreshToken) {
      const message = {
        type: "oauth-success",
        payload: { accessToken, refreshToken },
      }
      // 부모 창의 origin으로 메시지 전송
      // 실제 운영 환경에서는 '*' 대신 정확한 부모 창의 origin을 명시해야 합니다.
      window.opener?.postMessage(message, "*")
    }

    window.close()
  }, [])

  return <div>로그인 처리 중...</div>
}

export default OAuth2RedirectHandler
